export { default as Avatar } from './Avatar'
export { default as StyledAvatar } from './Avatar.Styled'